const rankingData = [
  { rank: 1, title: '暗夜追凶', heat: '987万', tag: '悬疑热播', change: 'up' },
  { rank: 2, title: '春风十里不如你', heat: '876万', tag: '都市情感', change: 'up' },
  { rank: 3, title: '星辰大海', heat: '765万', tag: '科幻新剧', change: 'new' },
  { rank: 4, title: '长安秘事录', heat: '698万', tag: '古装探案', change: 'up' },
  { rank: 5, title: '追光者', heat: '612万', tag: '都市职场', change: 'down' },
  { rank: 6, title: '山海异兽录', heat: '545万', tag: '奇幻冒险', change: 'up' },
  { rank: 7, title: '漫长的告白', heat: '489万', tag: '爱情文艺', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-fire-line"></i>
            实时热度
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热播榜单 · 大家都在看
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            聚合妖精视频、桃花视频、苹果视频等平台实时热度排行，发现全网最热新剧
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-4 md:px-6 py-4 border-b border-background-200 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer group rounded-lg"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm flex-shrink-0 ${
                item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-950 font-medium text-sm md:text-base truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>

              <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap hidden sm:inline-block">
                {item.tag}
              </span>

              <div className="flex items-center gap-1 flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-red-400 text-sm"></i>}
                {item.change === 'new' && <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">NEW</span>}
                <span className="text-foreground-600 text-xs md:text-sm font-medium">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}